import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation GenerateAgreementsForAutopay(
    $input: GenerateAgreementsForAutopayInput!
  ) {
    generateAgreementsForAutopay(input: $input) {
      __typename
      ... on GenerateAgreementsForAutopaySuccess {
        agreements {
          id
          title
          type
          resource {
            htmlId
            pdfId
            textId
            textDocumentHtml
          }
          productType
        }
      }
      ... on GenerateAgreementsForAutopayError {
        ...error
      }
    }
  }
  ${error}
`;
